import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

import { STORAGE_KEYS } from '@/data/constants/storage';
import { storageService } from '@/data/services/storage.service';

const createApiInstance = (): AxiosInstance => {
  const instance = axios.create({
    baseURL: process.env.VITE_APP_API_URL || '',
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });

  instance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      // * Always try to get and attach the token if available
      const envToken = process.env.VITE_APP_BEARER_TOKEN;
      const token =
        envToken || storageService.get<string>(STORAGE_KEYS.AUTH_TOKEN);

      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      // * Only redirect to login for authentication endpoint failures
      // * This prevents non-auth API errors from triggering a page reload
      const isAuthEndpoint = error.config?.url?.includes('/me');
      const is401Error = error.response?.status === 401;
      const shouldRedirect =
        is401Error && isAuthEndpoint && !error.config?.skipAuthRedirect;

      if (shouldRedirect) {
        storageService.remove(STORAGE_KEYS.AUTH_TOKEN);
        storageService.remove(STORAGE_KEYS.USER_CACHE);

        const loginUri = `${String(process.env.VITE_APP_LOGIN_URL)}?redirect_uri=${
          window.location.href
        }`;
        window.location.href = loginUri;
      }

      return Promise.reject(error);
    },
  );

  return instance;
};

export const apiInstance = createApiInstance();
